import { render, staticRenderFns } from "./MapaAreaAtuacao.vue?vue&type=template&id=0ecc0336&scoped=true&"
import script from "./MapaAreaAtuacao.vue?vue&type=script&lang=js&"
export * from "./MapaAreaAtuacao.vue?vue&type=script&lang=js&"
import style0 from "./MapaAreaAtuacao.vue?vue&type=style&index=0&id=0ecc0336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc0336",
  null
  
)

export default component.exports